import React from 'react';
import { Link } from 'react-router-dom';

export default function IndexSectionCallToAction8() {
    return (
        <React.Fragment>
            <>
                <section className="relative py-20 lg:py-40">
  <img className="hidden lg:block lg:absolute top-0 left-0 mt-32" src="zeus-assets/icons/dots/blue-dot-left-bars.svg" alt />
  <img className="h-16 mt-4 ml-auto lg:hidden" src="zeus-assets/icons/dots/yellow-dot-right-shield.svg" alt />
  <img className="hidden lg:block lg:absolute top-0 right-0 mt-64" src="zeus-assets/icons/dots/yellow-dot-right-shield.svg" alt />
  <div className="relative container px-4 mx-auto">
    <div className="max-w-3xl mx-auto text-center">
      <h2 className="mt-8 mb-6 lg:mb-10 text-4xl font-semibold font-heading">Let us help you organize your data</h2>
      <p className="mb-6 lg:mb-12 text-xl text-gray-500">If you have ever wondered howe we can help you organize your documents and photos, reach out to us now!</p>
      <Link to="/register" className="inline-block w-full md:w-auto mb-2 mr-4 py-4 px-8 text-sm font-medium leading-normal bg-red-400 hover:bg-red-300 text-white rounded transition duration-200">Request a Demo</Link><a className="inline-block w-full md:w-auto mb-2 py-4 px-8 text-sm font-medium leading-normal border border-gray-300 hover:border-gray-400 rounded" href="mailto:?subject=Check out Ordio&body=I found this great AI-powered organization tool: ">Share with friends</a>
    </div>
  </div>
</section>


            </>
        </React.Fragment>
    );
}

